import React, { memo, useState } from 'react';
import classnames from 'classnames';
import { IconLoader } from 'common/IconLoader';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import ProvisionModal from 'components/features/ProvisionModal/ProvisionModal';

const BundleOverviewControllerGa2RogueTab = ({ id, device, donorDevice, deviceType, activeIndex }) => {
  const [isProvisionModalOpen, setIsProvisionModalOpen] = useState(false);

  return (
    <div
      id={`BundleOverviewControllerTab_${deviceType}_${id}`}
      key={id}
      className={classnames('BundleOverviewControllerTab', {
        BundleOverviewControllerTabFocus: activeIndex === device?.deviceId,
        BundleOverviewControllerGa2RogueTab: true
      })}
    >
      {isProvisionModalOpen && (
        <ProvisionModal targetDevice={donorDevice} onClose={() => setIsProvisionModalOpen(false)} />
      )}
      <div className="BundleOverviewControllerTabDeviceLabel">
        <SvgAF img={IconLoader.icon_service_disabled} />
        <div className="BundleOverviewControllerTabDeviceLabelId" data-tip={device?.deviceId}>
          {device?.deviceId || device?.id}
        </div>
      </div>

      <div
        className={classnames('BundleOverviewControllerTabBottomContainer', {
          BundleOverviewControllerGa2RogueTabBottomerContainer: true
        })}
      >
        <div>Provision is required to use this SU.</div>
        <button
          className={classnames('BundleOverviewControllerTabBottomContainer_ReviewBtn')}
          onClick={() => {
            setIsProvisionModalOpen(true);
          }}
        >
          Review Sector
        </button>
      </div>
    </div>
  );
};

export default memo(BundleOverviewControllerGa2RogueTab);
